import './CodeSnippet.css';
import React from 'react';
import { get } from "../../utils";
// https://stackoverflow.com/questions/14644558/call-javascript-function-after-script-is-loaded
function loadScript(url, callback) {
  const script = document.createElement("script");
  script.type = "text/javascript";
  if (script.readyState) {
    // only required for IE <9
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    //Others
    script.onload = function () {
      callback();
    };
  }
  script.src = url;
  document.getElementsByTagName("head")[0].appendChild(script);
}
const CodeSnippet = _ref => {
  let {
    fields,
    params
  } = _ref;
  const ref = React.useRef();
  const snippet = get(fields, 'data.item.code.jss.value', '');
  const scripts = get(fields, 'data.item.scripts.jss.value', '');
  React.useEffect(() => {
    const strt = scripts.indexOf('src="');
    const end = scripts.indexOf('">', strt);
    const scriptLib = scripts.slice(strt + 5, end);
    loadScript(scriptLib, () => {
      const script = document.createElement('script');
      const strt = scripts.indexOf('<script>', end);
      const end2 = scripts.indexOf('</script>', strt);
      script.innerHTML = scripts.slice(strt + 8, end2);
      ref.current.appendChild(script);
    });
    return () => {
      ref.current.innerHTML = '';
    };
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles,
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: snippet
    }
  });
};
export const commonStyles = "c10att56";
export default CodeSnippet;